import {Alert, Card, CardBody, CardHeader, Image, Spinner} from "@heroui/react";
import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {apiClientExporter} from "../../services/apiClient";


const ExporterActivateAccount = () => {
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect( () => {
        setLoading(true);
        setError(null)
        setMessage(null)

        if (code) {
            checkAndActivate(code)
        } else {
            setMessage('Invalid activation code');
        }
    }, [code]);

    const checkAndActivate = async (code) => {
        try {
            const response = await apiClientExporter.get(`/auth/verify_account/${code}`, {
                headers: {
                    "Content-Type": "application/json"
                },
            });

            if(response.status !== 200){
                throw new Error(response.data.message);
            }

            console.log("responsess", response);

            setMessage(response.data.message);

            const data = response.data;
            console.log("activationdata", data);
        } catch (err) {
            setMessage(null);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="flex justify-center items-center min-h-screen">
            <Card className="max-w-[400px]">
                <CardHeader>
                    <Image
                        alt="QuickView logo"
                        height={40}
                        radius="sm"
                        src={process.env.PUBLIC_URL + "/QuickViewR.png"}
                        width={270}
                    />
                    <Image
                        src= {process.env.PUBLIC_URL + "/PoweredBy.png"}
                        className="max-w-[70px] max-h-[40px] object-contain"
                        width={70}
                        height={40}
                        alt="AWS Logo"
                    />
                </CardHeader>
                <CardBody>
                    <div className="p-4 text-center">
                        {loading &&
                            <Spinner animation="border" />
                        }
                        {message &&
                            <Alert hideIcon color="success" description="" title={message} variant="faded" />
                        }
                        {error &&
                            <Alert hideIcon color="danger" description="" title={error} variant="faded" />
                        }
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default ExporterActivateAccount;